import { Component, Input,  ElementRef, ViewChildren, QueryList, HostListener } from "@angular/core";
import { Subscription } from 'rxjs';
import { CommonService } from "@app/services/common.service";
import { c_components } from "../../..";
import { Helper } from "src/4services/2helper";
import ims from '../../imports';

@Component({
    selector: "c_dtable_automated_incident_settings_component",
    templateUrl: "./c_dtable_automated_incident_settings_component.html",
    styleUrls: ["../../common.scss", "../automated_incident_settings.scss"],
    standalone: false
})
export class c_dtable_automated_incident_settings_component {
  // ------------------------------------------------------------------------
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>

  isLoading: boolean = false;
  isHasViewPermission: boolean = false;
  isBasicPlan: boolean = false;

  tableHeader = [
    { name: 'INCIDENT TYPE', value: 'incident_type_name', width: "20%" },
    { name: 'SUB CATEGORY', value: null, width: "70%" },
    { name: '', value: null, width: "5%" },
  ]
  incidentTypeList = []

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.incidentTypeList.forEach(type=> {
          if (`type-${type.id}` === actionMenu.nativeElement.id) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              type.isShowMenu = false;
            }
          }
        })
      })
    }
  }

  constructor(private helper: Helper, private commonService: CommonService, private c_components: c_components){}
  private incident_report_types$w: Subscription;
  watch() {
    this.incident_report_types$w = this.helper.incident_reports.incident_types$w().subscribe(v => this.on_changed_value(v))
  }
  unwatch() {
    this.incident_report_types$w?.unsubscribe();
  }

  async ngOnInit(){
    this.isLoading = false;
    await this.helper.permission.load_my_permissions_only_if_not_loaded();
    await this.getDealerPlan();
    
    this.watch();
    this.isHasViewPermission = this.helper.permission.has('dealer_site_incident_type_read')
    await this.getIncidentTypes();
    this.isLoading = false;
  }
  ngOnDestroy(){
    this.unwatch();
  }

  async getDealerPlan(){
    try {
      await this.helper.dealer_plan.get_dealer_plan()
      this.isBasicPlan = this.helper.dealer_plan.isStandardPlan()
    } catch(err) {
      this.isLoading = false;
    }
  }
  async getIncidentTypes(){
    try {
      if(!this.isHasViewPermission) return
      await this.helper.incident_reports.load_incident_types()
    } catch(err) {
      this.isLoading = false;
    }
  }

  on_changed_value(v){
    if(!this.isHasViewPermission) return
    if(!v || !v[0]) return;
    this.incidentTypeList = v
  }
  // ------------------------------------------------------------------------
  determineElementToShow(){
    if(this.isLoading) return false
    if(!this.isHasViewPermission || this.isBasicPlan) return 'no-permission'
    if(!this.incidentTypeList?.length) return 'no-data'
    return 'normal'
  } 
  
  toggleMenu(type){
    const targetMenu = type.isShowMenu;
    type.isShowMenu = !targetMenu;
  }

  setMorePosition(type) {
    const docElem = document.documentElement
    let elem = document.getElementById('type-'+type?.id);
    let more = document.getElementById('type-more-'+type?.id);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right + 5
    const posY = rect.top - 22;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  goToDetail(type){
    this.helper.router.navigate_to(`/reports/automated-incident/${type.id}`);
  }

  // -----------------------------------------------
  // ACTION
  openEditDialog(event, type){
    event.stopPropagation();

    this.c_components.dialog.open('incident_type', {
      incident_type_id: type.id,
      incident_type_name: type.name,
      incident_type_description: type.description
    })
  }

  openDeleteDialog(event, type){
    event.stopPropagation();
    type['isShowMenu'] = false;

    this.c_components.dialog.open("warning", {
      header: 'Delete Incident Type',
      contents: `
        <p>
        Are you sure you want to delete the Incident Type '${type.name}'?
        </b></p>
      `,
      submit_btn: "Confrim",
      submit_class: ["button-danger"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: async () => await this.deleteIncdientType(type),
    })
  }

  async deleteIncdientType(type){
    try {
      const typeId = type?.id;
      if(!typeId) return;

      this.isLoading = true;
      await this.helper.incident_reports.delete_incident_type(typeId);
      await ims.tool.sleep(100);
      await this.helper.incident_reports.load_incident_types();
      this.commonService.showSuccessToast('Delete the Incident Type','Success');
      this.isLoading = false;
    } catch(err) {
      this.isLoading = false;
    }
  }


  // -----------------------------------------------
  compare(a: number | string | null, b: number | string | null, isAsc: boolean) {
    if (a === null && b === null) return 0; 
    if (a === null) return isAsc ? -1 : 1; 
    if (b === null) return isAsc ? 1 : -1; 
    
    if (typeof a === 'string') a = a.toLocaleLowerCase();
    if (typeof b === 'string') b = b.toLocaleLowerCase();
    
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  sortTableByColumn(sortTarget) {
    if (!sortTarget.sortColumn || sortTarget.sortDirection === '') {
      return;
    }
    let data = this.incidentTypeList;

    const tmpData = data.sort((a, b) => {
      const isAsc = sortTarget.sortDirection === 'asc';
      switch (sortTarget.sortColumn) {
        case 'incident_type_name': 
          return this.compare(a.name, b.name, isAsc);
        default: return 0;
      }
    });
    
    this.incidentTypeList = tmpData;
  }
}
